import Vue from 'vue'
import App from './App.vue'
import store from './store'

import moment from 'moment'
import VueProgressiveImage from 'vue-progressive-image'
import VueJsonp from 'vue-jsonp'


import 'moment/locale/en-gb'
import MaskedInput from 'vue-text-mask'

import 'isomorphic-fetch'

import './assets/styles/components/normalize.min.css'
import './assets/styles/main.scss'

import urlParams from './helpers/getUrlParams'


const SSO_REDIRECT_LINK = 'https://luxoft.sailplay.com/saml2/login/?idp=https://sts.windows.net/df7fa6cf-2f69-491d-bacd-8caa90484c7b/&next=https://luxoft.sailplay.com?partner_id=1954'



Vue.component('masked-input', MaskedInput)
Vue.use(require('vue-moment'), {
  moment
})
Vue.use(VueJsonp)

Vue.use(VueProgressiveImage)

Vue.config.productionTip = false

Vue.prototype.$eventBus = new Vue()

Vue.filter('tagExist', tag => {
  let tags = store.getters.currentTags || []
  return !!tags.find(item => item.tag === tag)
})

Vue.filter('pluralize', (value, titles) => {
  let cases = [2, 0, 1, 1, 1, 2]
  titles = titles.split(',')
  return titles[(value % 100 > 4 && value % 100 < 20) ? 2 : cases[(value % 10 < 5) ? value % 10 : 5]]
})

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) {
        warn += `Found in component '${compName}'`
      }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
})

new Vue({
  render: h => h(App),
  store,
  beforeCreate: () => {
    let auth_hash = urlParams.getUrlParameter('auth_hash')
    let initedPopup = urlParams.getUrlParameter('p')
    document.cookie = `auth_hash_cookie=${auth_hash}`
    window.history.replaceState(
      {},
      document.title,
      '/' + (initedPopup ? '?p=' + initedPopup : ""));

    Vue.moment().locale('en')

    store.dispatch('init').then(() => {
      store.dispatch('checkLogin')
        .catch(() => {
          if (initedPopup) {
            window.location = SSO_REDIRECT_LINK + '%26p=' + initedPopup
          } else {
            window.location = SSO_REDIRECT_LINK
          }
        })
    })

  }
}).$mount('#app')
